// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconListCheck, IconUserPlus, IconFileInfo, IconAlignCenter, IconBoxModel2, IconBoxModel, IconList } from '@tabler/icons';

// constant
const icons = {
    IconListCheck,
    IconUserPlus,
    IconFileInfo,
    IconAlignCenter,
    IconBoxModel2,
    IconBoxModel,
    IconList
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const employeeAdvanceGroup = {
    id: 'employee-advance-group',
    type: 'group',
    children: [
        {
            id: 'employee-advance',
            title: <FormattedMessage id="my-advances" />,
            type: 'collapse',
            breadcrumbs: false,
            icon: icons.IconBoxModel2,
            children: [
                {
                    id: 'new-advance',
                    title: <FormattedMessage id="new-advance" />,
                    type: 'item',
                    url: '/advance-form',
                    icon: icons.IconFilePlus,
                    breadcrumbs: false,
                    visible: true
                },
                {
                    id: 'my-advances',
                    title: <FormattedMessage id="my-advances" />,
                    type: 'item',
                    url: '/advance-list?type=my_advances',
                    icon: icons.IconFiles,
                    breadcrumbs: false,
                    visible: true
                },
            ]
        },
    ]
};

export default employeeAdvanceGroup;
